// Creators API resource names (lowerCamelCase, replaces PA-API v5 PascalCase)
export const AMAZON_API_RESOURCES_BASE = [
  "itemInfo.title",
  "itemInfo.features",
  "itemInfo.byLineInfo",
  "offersV2.listings.price",
  "offersV2.listings.condition",
  "offersV2.listings.dealDetails",
  "offersV2.listings.isBuyBoxWinner",
  "offersV2.listings.merchantInfo",
  "offersV2.listings.availability",
  "images.primary.large",
  "images.variants.large",
];

export const AMAZON_API_SEARCH_RESOURCES = AMAZON_API_RESOURCES_BASE;
export const AMAZON_API_GET_ITEMS_RESOURCES = AMAZON_API_RESOURCES_BASE;
export const AMAZON_API_RESOURCES = AMAZON_API_RESOURCES_BASE;
export const COFFEEBUY_FACEBOOK_GROUP_ID = "335542807953374";
export const ALIEXPRESS_TRACKING_ID = "alonseg";
export const ALIEXPRESS_APP_SIGNATURE = "CoffeeBuy";
export const SEARCH_ITEMS_COUNT = 7;
export const TOO_MANY_REQUESTS_RETRIES = 3;
// Live searches fan out across 6 Amazon domains sequentially. Under the
// adaptive rate limiter's max backoff (MAX_INTERVAL_MS = 8000ms in
// rateLimitService.js), calls can be spaced up to 8s apart, so a full pass
// across all 6 domains can cost up to ~48s alone, before any real API
// latency. A shorter deadline here cuts the loop off after only the first
// domain or two, silently returning partial (e.g. Germany-only) results.
// If the Amazon rate limiter is currently backed off, don't let one search
// hang behind it indefinitely — stop trying further domains past this
// deadline and return whatever results were already gathered.
export const SEARCH_DOMAIN_LOOP_DEADLINE_MS = 60000;
export const PRICES_CHECK_INTERVAL = 5 * 60 * 1000; // every 5 minutes
export const COUPONS_SPREADSHEET_ID =
  "1lqFvBEJdcygryc0dA3I54VQO_9vIRZYVPwsrzvgsz0Q";
export const ADDITIONAL_ITEM_PARAGRAPHS = {
  de: " כמו למשל עפרונות https://amzn.to/4hcWOwT",
  it: " כמו למשל מברשת שיניים https://amzn.to/3w31UUD",
  "co.uk": " כמו למשל עט https://amzn.to/3rFqd7V",
  fr: " כמו למשל פתקים https://amzn.to/3BQCJvY",
  es: " כמו למשל נעצים https://amzn.to/3nqrFfn",
};
export const COMPANIES_DESCRIPTIONS = {
  breville: "",
  sage: "",
  delonghi: "",
  melitta:
    'חברת Melitta הינה חברה גרמנית אשר הוקמה 1908 ע"י ממציאת פילטר הנייר לקפה. מכונות מליטה מיוצרות בתהליך קפדני עם בקרת איכות מהטובות ביותר.',
  lelit:
    "חברת Lelit הינה חברה איטלקית המייצרת מכונות מקצועיות לבתי קפה ובתים פרטיים,היא דוגלת בעיצובי רטרו פרקטיים. החברה משקיעה בייצור מסורתי תוצרת איטליה",
};
export const COMPANIES_ADDITIONAL_ITEMS = {
  breville:
    "https://www.facebook.com/groups/335542807953374/posts/341232697384385",
  sage: "https://www.facebook.com/groups/335542807953374/posts/341232697384385",
  "sage appliances":
    "https://www.facebook.com/groups/335542807953374/posts/341232697384385",
  delonghi: "",
  melitta:
    "https://www.facebook.com/groups/335542807953374/posts/431917964982524/",
  lelit:
    "https://www.facebook.com/groups/335542807953374/posts/356901025817552/",
};
export const SHARE_INVITE_TEXT = `מכירים מישהו שזה בדיוק הדיל בשבילו? שתפו ותייגו!`;
export const AVAILABILITY_TYPE_NOW = "Now";
export const AVAILABILITY_TYPE_IN_STOCK = "IN_STOCK";
export const AVAILABILITY_TYPE_IN_STOCK_SCARCE = "IN_STOCK_SCARCE";
export const AVAILABILITY_TYPE_LEADTIME = "LEADTIME";
export const AVAILABILITY_TYPE_BACKOREDERABLE = "Backorderable";
export const COFFEE_BUY_DEV_CHANNEL_ID = -1001295059106;
export const COFFEE_BUY_PHOTOS_CHANNEL_ID = -1001505155737;
export const COFFEE_BUY_LOGS_CHANNEL_ID = -1001538425883;
export const COFFEE_BUY_ERRORS_CHANNEL_ID = -1001776606242;
export const COFFEE_BUY_CHANNEL_ID = -1001309565824;
export const COFFEE_BUY_SCRAPER_UPDATES_CHANNEL_ID = -1002008908686;
// AMAZON_API_ACCESS_KEY = 'AKIAIYFFWI4DZTVH4UOA';
export const AMAZON_API_DOMAIN_PARAMETERS = {
  de: {
    PartnerTag: "botimza-21",
    Marketplace: "www.amazon.de",
  },
  fr: {
    PartnerTag: "coffeebuyil07-21",
    Marketplace: "www.amazon.fr",
  },
  it: {
    PartnerTag: "coffeebuyil0c-21",
    Marketplace: "www.amazon.it",
  },
  "co.uk": {
    PartnerTag: "coffeebuyil00-21",
    Marketplace: "www.amazon.co.uk",
  },
  com: {
    PartnerTag: "coffeebuyil-20",
    Marketplace: "www.amazon.com",
  },
  es: {
    PartnerTag: "coffeebuyi090-21",
    Marketplace: "www.amazon.es",
  },
  "co.jp": {
    PartnerTag: "botimza-22",
    Marketplace: "www.amazon.co.jp",
  }
};
export const AMAZON_BOT_API_DOMAIN_PARAMETERS = {
  de: {
    PartnerTag: "botimza-21",
    Marketplace: "www.amazon.de",
    LanguagesOfPreference: ["en_GB"],
  },
  fr: {
    PartnerTag: "bot-coffeebuyil07-21",
    Marketplace: "www.amazon.fr",
  },
  it: {
    PartnerTag: "bot-coffeebuyil0c-21",
    Marketplace: "www.amazon.it",
  },
  "co.uk": {
    PartnerTag: "bot-coffeebuyil00-21",
    Marketplace: "www.amazon.co.uk",
  },
  com: {
    PartnerTag: "bot-coffeebuyil-20",
    Marketplace: "www.amazon.com",
  },
  es: {
    PartnerTag: "bot-coffeebuyi090-21",
    Marketplace: "www.amazon.es",
  },
  // "co.jp": {
  //   PartnerTag: "botimza-22",
  //   Marketplace: "www.amazon.co.jp",
  // },
};
export const AMAZON_API_COMMON_PARAMS = {};

export const TRUSTED_MERCHANTS = [
  "kingrinder",
  "flair espresso",
  "1zpresso",
  "amazon",
  "miicoffee",
  "fellow industries",
  "amazon.es",
  "amazon.com",
  "amazon.it",
  "amazon.fr",
  "amazon.de",
  "amazon.co.uk",
  "amazon.co.jp",
  "amazon.ca",
  "amazon.com.au",
  "amazon.com.br",
  "amazon.com.mx",
  "amazon.cn",
  "amazon.in",
  "amazon.nl",
  "amazon.sg",
  "amazon.se",
  "amazon.ae",
  "amazon.sa",
  "amazon.com.tr",
  "amazon.pl",
];
export const AMAZON_API_QUERY_PARAMS_BASE = {
  ItemIdType: "ASIN",
  Resources: AMAZON_API_RESOURCES,
};

export const AMAZON_API_QUERY_PARAMS = {
  Condition: "New",
  Merchant: "Amazon",
  ...AMAZON_API_QUERY_PARAMS_BASE,
};

export const AMAZON_API_SEARCH_QUERY_PARAMS_BASE = {
  ItemCount: SEARCH_ITEMS_COUNT,
  Availability: "Available",
  Resources: AMAZON_API_SEARCH_RESOURCES,
};

export const AMAZON_API_SEARCH_QUERY_PARAMS = (searchTerm) => ({
  Keywords: searchTerm,
  ...AMAZON_API_SEARCH_QUERY_PARAMS_BASE,
});
